import { render } from "./mpesaPayments.vue?vue&type=template&id=d4ff31ea&scoped=true"
import script from "./mpesaPayments.vue?vue&type=script&lang=js"
export * from "./mpesaPayments.vue?vue&type=script&lang=js"

import "./mpesaPayments.vue?vue&type=style&index=0&id=d4ff31ea&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/itibo/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4ff31ea"]])

export default __exports__